import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import yup from 'yup'
import Form from 'react-formal'
import types from 'react-formal-inputs'
import 'react-widgets/lib/less/react-widgets.less'
import { Alert, Checkbox, Col } from 'react-bootstrap'
import { DropdownList } from 'react-widgets'

class AppAdd extends Component {

    constructor(props) {
        super(props)

        this.state = {
            formValues: {},
            addedToken: null,
            marketplace: false,
            platformSelected: {name: 'Mercado Pago', code: 'mp'},
            platform: [{name: 'Mercado Pago', code: 'mp'}],
            countrySelected: {name: 'Argentina', code: 'AR'},
            countries: [{name: 'Argentina', code: 'AR'}],
            loading: false
        }

        Form.addInputTypes(types)
        momentLocalizer(moment)
    }

    getModelSchema() {
        var self = this
        var yupSchema = {}
        if (self.state.marketplace) {
            yupSchema = {
                name: yup.string().required('Ingrese nombre'),
                codename: yup.string().required('Ingrese codename'),
                publicKey: yup.string().required('Ingrese public Key'),
                accessToken: yup.string().required('Ingrese accessToken'),
                appId: yup.string().required('Ingrese app Id'),
                appSecret: yup.string().required('Ingrese app Secret'),
                fee: yup.string().required('Ingrese fee')
            }
        } else {
            yupSchema = {
                name: yup.string().required('Ingrese nombre'),
                codename: yup.string().required('Ingrese codename'),
                publicKey: yup.string().required('Ingrese public Key'),
                accessToken: yup.string().required('Ingrese accessToken'),
                appId: yup.string().nullable(),
                appSecret: yup.string().nullable(),
                fee: yup.string().nullable()
            }
        }
        return yup.object(yupSchema)
    }

    goBack() {
        browserHistory.go(-1)
    }

    registerAppForm(formValues) {
        var self = this
        var name = formValues.name
        var codename = formValues.codename
        var publicKey = formValues.publicKey
        var accessToken = formValues.accessToken
        var appId = formValues.appId
        var appSecret = formValues.appSecret
        var fee = formValues.fee

        let payments = {}
        let mercadopago = {}
        let app = {}
        if (self.state.platformSelected.code === 'mp') {
            if (appId && appId !== '') {
                app.id = appId
            }
            if (appSecret && appSecret !== '') {
                app.secret = appSecret
            }
            if (fee && fee !== '' && self.state.marketplace) {
                app.fee = fee
            }
            if (app && app !== {}) {
                mercadopago.app = app
            }
            if (publicKey && publicKey !== '') {
                mercadopago.publicKey = publicKey
            }
            if (accessToken && accessToken !== '') {
                mercadopago.accessToken = accessToken
            }
            if (mercadopago && mercadopago !== {}) {
                payments.mercadopago = mercadopago
            }
        }
        var object = {
            name: name,
            codename: codename,
            marketplace: self.state.marketplace,
            country: self.state.countrySelected.code,
            payments: payments
        }

        self.setState({ loading: true })
        self.props.actions.appAdd(object).then(function(action) {
            self.setState({ addedToken: action.payload.data.token, loading: false })
            return Promise.resolve()
        })
    }

    render() {
        var self = this
        var content = null
        var modelSchema = self.getModelSchema()
        if (self.state.addedToken) {
            content = (
                <Alert id="alertError" bsStyle="warning" onDismiss={self.goBack.bind(self)}>
                    <strong>App successfully created</strong><br/><br/>
                    App token is
                    <strong> {self.state.addedToken}</strong><br/><br/>
                    <em>Can't recover token after this window is closed. You can create another token if needed.</em><br/><br/>
                    <button className='btn btn-primary' onClick={self.goBack.bind(self)}>Cerrar</button>
                </Alert>
            )
        } else {
            var contentPlatform
            if (self.state.platformSelected.code === 'mp') {
                contentPlatform = <div>
                  <div className='row'>
                      <div className='form-group col-md-12'>
                          <h3 className='page-header'>Datos Mercadopago</h3>
                      </div>
                  </div>
                  <div className='row'>
                      <div className='form-group col-md-6'>
                          <label>Public Key</label>
                              <Form.Field name='publicKey' placeholder='Public Key' className='form-control'/>
                          <Form.Message for={'publicKey'}/>
                      </div>
                      <div className='form-group col-md-6'>
                          <label>Access Token</label>
                              <Form.Field name='accessToken' placeholder='Access Token' className='form-control'/>
                          <Form.Message for={'accessToken'}/>
                      </div>
                  </div>
                  <div className='row'>
                      <div className='form-group col-md-6'>
                          <label>App Id</label>
                              <Form.Field name='appId' placeholder='App Id' className='form-control'/>
                          <Form.Message for={'appId'}/>
                      </div>
                      <div className='form-group col-md-6'>
                          <label>App Secret</label>
                              <Form.Field name='appSecret' placeholder='App Secret' className='form-control'/>
                          <Form.Message for={'appSecret'}/>
                      </div>
                  </div>
                  <div className='row'>
                      <div className='form-group col-md-2' key='marketplace'>
                          <Col>
                            <Checkbox onChange={() => self.setState({ marketplace: !self.state.marketplace })} defaultChecked={self.state.marketplace}>
                                Marketplace
                            </Checkbox>
                          </Col>
                      </div>
                      <div className='form-group col-md-2' style={ (self.state.marketplace) ? { display: '' } : { display: 'none' }}>
                          <label>Fee %</label>
                              <Form.Field name='fee' placeholder='0' className='form-control'/>
                          <Form.Message for={'fee'}/>
                      </div>
                  </div>
                </div>
            }
            content = (
                <Form schema={modelSchema} defaultValue={modelSchema.default()} onChange={(formValues, fieldUpdated) => {
                    var newState = {
                        formValues: formValues
                    }
                    self.setState(newState)
                }} onSubmit={self.registerAppForm.bind(self)}>
                    <div className='row'>
                        <div className='form-group col-md-5'>
                            <label>Nombre</label>
                            <Form.Field name='name' placeholder='Name' className='form-control'/>
                            <Form.Message for='name'/>
                        </div>
                        <div className='form-group col-md-5'>
                            <label>Codename</label>
                            <Form.Field name='codename' placeholder='Codename' className='form-control'/>
                            <Form.Message for='codename'/>
                        </div>
                        <div className='form-group col-md-2'>
                            <label>Pais</label>
                            <DropdownList
                                valueField='code'
                                textField='name'
                                data={self.state.countries}
                                value={self.state.countrySelected.name}
                                onChange={value => self.setState({countrySelected: value})}/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='form-group col-md-5' key='platform'>
                            <label>Plataforma</label>
                            <DropdownList
                                valueField='code'
                                textField='name'
                                data={self.state.platform}
                                value={self.state.platformSelected.name}
                                onChange={value => self.setState({platformSelected: value})}/>
                        </div>
                    </div>
                    {contentPlatform}
                    <div className='pull-right'>
                        <Form.Button type='submit' className='btn btn-primary' disabled={ self.state.loading }>Save</Form.Button>
                        &nbsp;
                        <button className="btn btn-danger" type="button" onClick={self.goBack.bind(self)} disabled={ self.state.loading }>Cancel</button>
                    </div>
                </Form>
            )
        }
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1 className="page-header">Add App</h1>
                    </div>
                </div>
                <div className="row">
                    { content }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        apps: state.apps
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(AppAdd)



// WEBPACK FOOTER //
// ./components/AppAdd/index.js